function minMaxInt(low, high, value) {
    return Math.min(Math.max(value, low), high);
}

export default (minMaxInt);